/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import isNumber from 'lodash/isNumber';

/**
 * @import { Destroyable } from '../../destroyable'
 */

// TODO Unit testy.
/**
 * Správce zpoždění, jako ochrany proti zacyklení prolínače.
 * Detekuje průchod celým cyklem přehrávaných médií a aplikuje zpoždění.
 * @implements {Destroyable}
 */
export default class ViewerDelayer {
  /**
   * Vytvoří instanci.
   * @param {Object} [opts={}] Nepovinné parametry.
   * @param {number} [opts.delay=0] Zpoždění, které se aplikuje při detekovaném zacyklení.
   * @param {number} [opts.limit=Infinity] Počet selhání v řadě, který se považuje za zacyklení.
   */
  constructor({ delay = 0, limit = Infinity } = {}) {
    if (!isNumber(delay)) {
      throw new TypeError(`Invalid delay ${delay}.`);
    }
    if (!isNumber(limit)) {
      throw new TypeError(`Invalid limit ${limit}.`);
    }
    // Aktuální počet selhání v řadě.
    this.count = 0;
    this.delay = delay;
    this.limit = limit;
    /** @type {ReturnType<typeof setTimeout> | undefined} */
    this.timeout = undefined;
  }

  /** @type {Destroyable['destroy']} */
  destroy() {
    clearTimeout(this.timeout);
  }

  /**
   * Informuje o selhání při zobrazení média.
   * @returns {Promise<void>} Vyřeší se po ošetření zacyklení při selhání.
   */
  fail() {
    return new Promise((resolve) => {
      // Určí se aktuální počet selhání.
      const count = this.count + 1;
      if (count > this.limit) {
        // Při přesažení povoleného počtu selhání se počítadlo resetuje.
        this.count = 0;
        // Aktivuje se pozdržení reakce na chybové události, aby neocházelo k zacyklení.
        // Pokud je zotavení pozdrženo, provede se až po zvoleném zpoždění.
        this.timeout = setTimeout(resolve, this.delay);
        return;
      }
      // Bez přesažení se počet uloží pro další použití.
      this.count = count;
      return resolve();
    });
  }

  /**
   * Informuje o úspěchu při zobrazení média.
   * @returns {Promise<void>} Vyřeší se po ošetření zacyklení při úspěchu.
   */
  succeed() {
    return new Promise((resolve) => {
      // Při úspěšně načteném slajdu se resetuje počítadlo selhání.
      this.count = 0;
      // Zpoždění u úspěchu se zatím neaplikuje nikdy.
      return resolve();
    });
  }
}
